module.exports = __webpack_public_path__ + "img/img24.2c89a309.png";